export default __webpack_public_path__ + "static/media/skip-icon.82ec0e46.svg";